import { TInputTag } from "components/InputMultipleTag";

import { TGetNotesFilter } from "./types";
import { TGetUserAccociatedBUListReq } from "@type/api/businessUnit/types";
import { TFinalSort } from "components/Table/types";
import { routePaths } from "routes/constants";

export const DEFAULT_PARAMS: TGetUserAccociatedBUListReq = {
  page: 1,
  pageSize: 24,
};

export const SORT_MAP_NOTES = {
  dateAndTime: "date_created",
  fieldName: "staff_type",
  pipelineStatusName: "pipeline_status",
  ticketName: "ticket",
  submitterName: "submitter",
  interviewType: "interview_type",
  jobListing: "joblisting",
  corporation: "corporation",
};

export const DEFAULT_SORT_NOTES: Record<string, TFinalSort> = {
  dateAndTime: {
    fieldName: "date_created",
    key: "dateAndTime",
    type: "desc",
  },
  staffType: {
    fieldName: "staff_type",
    key: "staffType",
    type: "none",
  },
  pipelineStatusName: {
    fieldName: "pipeline_status",
    key: "pipelineStatusName",
    type: "none",
  },
  interviewType: {
    fieldName: "interview_type",
    key: "interviewType",
    type: "none",
  },
  ticketName: {
    fieldName: "ticket",
    key: "ticketName",
    type: "none",
  },
  jobListing: {
    fieldName: "joblisting",
    key: "jobListing",
    type: "none",
  },
  email: {
    fieldName: "email",
    key: "email",
    type: "none",
  },
  submitterName: {
    fieldName: "submitter",
    key: "submitterName",
    type: "none",
  },
  corporation: {
    fieldName: "corporation",
    key: "corporation",
    type: "none",
  },
};

export const DEFAULT_FILTER_NOTES: TGetNotesFilter = {
  idBu: "",
  endDate: "",
  startDate: "",
  idPipelineStatus: "",
  idTicket: "",
  interviewType: "",
  staffType: "",
  keyword: "",
};

export const BUSINESS_UNIT_TABS = {
  insideSales: {
    label: "inside_sales",
    path: routePaths.root.bu.root.pBuSlug.pastNotes.insideSales.root,
  },
  fieldSales: {
    label: "field_sales",
    path: routePaths.root.bu.root.pBuSlug.pastNotes.fieldSales.root,
  },
  customerSuccess: {
    label: "customer_success",
    path: routePaths.root.bu.root.pBuSlug.pastNotes.customerSuccess.root,
  },
};

export const PERSONAL_ACCOUNT_TABS = {
  insideSales: {
    label: "inside_sales",
    path: routePaths.root.staff.root.pStaffSlug.pastNotes.insideSales.root,
  },
  customerSuccess: {
    label: "customer_success",
    path: routePaths.root.staff.root.pStaffSlug.pastNotes.customerSuccess.root,
  },
};

export const STAFF_TYPE_TAG_OPTIONS: TInputTag[] = [
  { id: "working_staff", name: "working_staff" },
  { id: "pool_staff", name: "pool_staff" },
  { id: "temporary_staff", name: "temporary_staff" },
];

export const INTERVIEW_TYPE_TAG_OPTIONS: TInputTag[] = [
  { id: "pool_staff_interview", name: "pool_staff_interview" },
  { id: "temporary_staff_interview", name: "temporary_staff_interview" },
  { id: "working_staff_interview", name: "working_staff_interview" },
];
